import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import _ from "lodash";

Vue.use(Vuex)

import lang from "@/api/lang.js";
import roteiros from "@/api/roteiros.js";
import noticias from "@/api/noticias.js";
import eventos from "@/api/eventos.js";
import contactos from "@/api/contactos.js";
import { decodeHtml } from "@/globalFunctions.js";
export default new Vuex.Store({
  state: {
    language: 'pt',
    idiomas: null,
    roteiros: [],
    roteiro:{},
    roteirosDest: [],
    noticias:[],
    noticia:{},
    noticiasDest:[],
    eventos:[],
    evento:{},
    eventosDest:[]
  },
  getters: {
    language: state => {
      return state.language
    },
    idiomas: state => {
      return state.idiomas
    },
    roteiros: state => {
      return state.roteiros
    },
    roteiro: state => {
      return state.roteiro
    },
    roteirosDest: state => {
      return state.roteirosDest
    },
    noticias: state => {
      return state.noticias
    },
    noticiasDest: state => {
      return state.noticiasDest
    },
    noticia: state => {
      return state.noticia
    },
    eventos: state => {
      return state.eventos
    },
    evento: state => {
      return state.evento
    },
    eventosDest: state => {
      return state.eventosDest
    }
  },
  mutations: {
    setLanguage(state, newLanguage) {
      state.language = newLanguage
    },
    async setIdiomas(state,idiomas) {
      state.idiomas = idiomas
    },
    async setRoteiros(state,_roteiros,_roteirosDest) {
      state.roteiros = _roteiros
      state.roteirosDest = _roteirosDest
    },
    async setRoteiro(state,roteiro) {
      state.roteiro = roteiro
    },
    async setNoticias(state,_noticias,_noticiasDest) {
      state.noticias = _noticias
      state.noticiasDest = _noticiasDest
    },
    async setNoticia(state,noticia) {
      state.noticia = noticia
    },
    async setEventos(state,_eventos,_eventosDest) {
      state.eventos = _eventos
      state.eventosDest = _eventosDest
    },
    async setEvento(state,evento) {
      state.evento = evento
    },
  },
  actions: {
    setLanguage(context, newLanguage) {
      context.commit('setLanguage', newLanguage)
    },
    async setIdiomas(context) {
      var idiomas = await lang.getIdiomas()
      context.commit('setIdiomas',idiomas)
      return idiomas
    },
    async setRoteiros(context) {
      var _roteirosDest = []
      var _roteiros = await roteiros.getRoteiros(this.state.language)

      _roteiros.map((roteiro) => {
        if (roteiro.destaque == 'true') {
          _roteirosDest.push(roteiro)
        }
      })

      context.commit('setRoteiros',_roteiros,_roteirosDest)
      return {roteiros:_roteiros,roteirosDest:_roteirosDest}
    },
    async setRoteiro(context, roteiroId) {
      var _roteiro = await roteiros.getRoteiro(this.state.language,roteiroId)
      var _galeria = []

      _roteiro.nome = decodeHtml(_roteiro.nome)
      _roteiro.categoria = decodeHtml(_roteiro.categoria)
      _roteiro.descricao = decodeHtml(_roteiro.descricao)

      _roteiro.blocos.map((bloco) =>{

        bloco.morada = decodeHtml(bloco.morada)
        bloco.nome = decodeHtml(bloco.nome)
        bloco.descricao = decodeHtml(bloco.descricao)
        bloco.position = {lat:parseFloat(bloco.bloco_lat),lng:parseFloat(bloco.bloco_lon)}

        if(_.isNull(bloco.galeria)){
          _galeria.push(bloco.imagem)
          bloco.galeria = _galeria
        }else{
          _galeria.push(bloco.imagem)
          bloco.galeria.map((img) =>{
            _galeria.push(img)
          })

          bloco.galeria = _galeria
        }

        _galeria = []
      })

      await context.commit('setRoteiro',_roteiro)

      return _roteiro
    },
    async setNoticias(context) {
      var _noticiasDest = []
      var _noticias = await noticias.getNoticias(this.state.language)
      
      _noticias.map((noticia) => {
        noticia.nome = decodeHtml(noticia.nome)
        noticia.categoria_nome = decodeHtml(noticia.categoria_nome)
        if (noticia.destaque == 'true') {
          _noticiasDest.push(noticia)
        }
      })

      context.commit('setNoticias',_noticias,_noticiasDest)
      return {noticias:_noticias,noticiasDest:_noticiasDest}
    },
    async setNoticia(context, noticiaId) {
      console.log('change')
      var _noticia = await noticias.getNoticia(this.state.language,noticiaId)
      var _galeria = []

      _noticia.nome = decodeHtml(_noticia.nome)
      _noticia.categoria = decodeHtml(_noticia.categoria)
      _noticia.descricao = decodeHtml(_noticia.descricao)

      if(Vue.lodash.isNull(_noticia.galeria)){
        _galeria.push(_noticia.imagem)
        _noticia.galeria = _galeria
      }else{
        _galeria.push(_noticia.imagem)
        _noticia.galeria.map((img) =>{

          _galeria.push(img)
        })
        _noticia.galeria = _galeria
      }

      await context.commit('setNoticia',_noticia)

      return _noticia
    },
    async setEventos(context) {
      var _eventosDest = []
      var _eventos = await eventos.getEventos(this.state.language)
      
      _eventos.map((evento) => {
        evento.nome = decodeHtml(evento.nome)
        evento.categoria_nome = decodeHtml(evento.categoria_nome)
        if (evento.destaque == 'true') {
          _eventosDest.push(evento)
        }
      })

      context.commit('setEventos',_eventos,_eventosDest)
      return {eventos:_eventos,eventosDest:_eventosDest}
    },
    async setEvento(context, eventoId) {
      console.log('change')
      var _evento = await eventos.getEvento(this.state.language,eventoId)
      var _galeria = []

      _evento.nome = decodeHtml(_evento.nome)
      _evento.categoria = decodeHtml(_evento.categoria)
      _evento.descricao = decodeHtml(_evento.descricao)

      if(Vue.lodash.isNull(_evento.galeria)){
        _galeria.push(_evento.imagem)
        _evento.galeria = _galeria
      }else{
        _galeria.push(_evento.imagem)
        _evento.galeria.map((img) =>{
          _galeria.push(img)
        })
        _evento.galeria = _galeria
      }

      await context.commit('setEvento',_evento)

      return _evento
    },
    async setContactoForm(context,params) {
      var _result = null
      try{
        _result = await contactos.sendContactForm(params)
      }catch(err){
        _result = false
      }
      
      return _result
    },
  },
  plugins: [createPersistedState()]
})

/* this.$store.getters.language) --> getLanguage */
